import type { IconColor } from '../types/Icon.types'

export const DEFAULT_ICON_SIZE = 24
export const DEFAULT_ICON_COLOR: IconColor = 'content-brand'
